import { IStateInit } from "@gtmhub/core/routing";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { IScope, IPromise } from "angular";
import { ISessionWorkflowStats } from "../models/models";
import { PlanningSessionService } from "../services/planningSessionService";

interface IInspectWorkflowService {
  planningSessionId: string;
}

export interface IInspectWorkflowCtrlScope extends IScope {
  indicators: {
    loading: boolean;
  };
  stats: ISessionWorkflowStats;
}

export class InspectWorkflowCtrl implements IStateInit {
  public static $inject = ["$scope", "$stateParams", "PlanningSessionService", "UIErrorHandlingService"];

  constructor(
    private $scope: IInspectWorkflowCtrlScope,
    private $stateParams: IInspectWorkflowService,
    private planningSessionService: PlanningSessionService,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {}

  public stateInit(): IPromise<unknown> {
    return this.init();
  }

  private init = (): IPromise<unknown> => {
    this.$scope.indicators = {
      loading: false,
    };

    this.$scope.indicators.loading = true;

    return this.planningSessionService.getWorkflowStats(this.$stateParams.planningSessionId).then(
      (stats) => {
        this.$scope.indicators.loading = false;

        this.$scope.stats = this.processStats(stats);
      },
      (err) => this.uiErrorHandlingService.handleIndicator(err, { indicator: "loading" })
    );
  };

  private processStats = (stats: ISessionWorkflowStats): ISessionWorkflowStats => {
    stats.averageApprovalPeriod = Math.round(stats.averageApprovalPeriod);

    return stats;
  };
}
